export default __webpack_public_path__ + "static/media/IV_Old_White.7da1e2ca.png";